export const TAGS_BLACK_LIST = [1, 2, 7, 12];
export const BLOG_EN = [
  5437, 3547, 3499, 3311, 2211, 2045, 1932, 1925, 1862, 1478, 1375,
];
export const BLOG_JP = [];
export const FILTERED_BLOG_ID = [2888];
